import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from "react";
import styles from "./EffektCheckbox.module.scss";
export const EffektCheckbox: React.FC<{
  checked: boolean;
  onChange: (checked: boolean) => void;
  dataCy?: string;
  required?: boolean;
  children: string | ReactNode;
}> = t0 => {
  const $ = _c(14);
  const {
    checked,
    onChange,
    dataCy,
    required,
    children
  } = t0;
  let t1;
  if ($[0] !== checked || $[1] !== onChange) {
    t1 = () => onChange(!checked);
    $[0] = checked;
    $[1] = onChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== checked || $[4] !== required) {
    t2 = <input type="checkbox" className={styles.input} tabIndex={-1} checked={checked} readOnly={true} required={required} />;
    $[3] = checked;
    $[4] = required;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.checkboxwrapper}><div className={styles.checkmark}>✓</div></div>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = <div className={styles.checkboxlabel}>{children}</div>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== dataCy || $[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <div className={styles.wrapper} onClick={t1} data-cy={dataCy}>{t2}{t3}{t4}</div>;
    $[9] = dataCy;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};